import { render, staticRenderFns } from "./UserReadForm.vue?vue&type=template&id=60fed4fe&scoped=true"
import script from "./UserReadForm.vue?vue&type=script&lang=js"
export * from "./UserReadForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60fed4fe",
  null
  
)

export default component.exports